export const INIT: "settings/INIT" = "settings/INIT";
export const TOGGLE_MEDIA_SIZE: "settings/TOGGLE_MEDIA_SIZE" =
  "settings/TOGGLE_MEDIA_SIZE";
